// import axios from 'axios';
import isEmpty from "../../utils/isEmpty";

import { UserDetail } from "../../../services/storage.service";

const state = {
  role: isEmpty(UserDetail.getUserRole()) ? "" : UserDetail.getUserRole(),
  freeProfileQuota: isEmpty(UserDetail.getUserQuota())
    ? ""
    : UserDetail.getUserQuota(),
  isDeleted: isEmpty(UserDetail.getUserIsDeleted())
    ? ""
    : UserDetail.getUserIsDeleted(),
  _id: isEmpty(UserDetail.getUserID()) ? "" : UserDetail.getUserID(),
  username: isEmpty(UserDetail.getUserName()) ? "" : UserDetail.getUserName(),
  email: isEmpty(UserDetail.getUserEmail()) ? "" : UserDetail.getUserEmail()
};

const getters = {
  getUserrole: state => state.role,
  getUserfreeProfileQuota: state => state.freeProfileQuota,
  getUserisDeleted: state => state.isDeleted,
  getUserId: state => state._id,
  getUserusername: state => state.username,
  getUseremail: state => state.email
};

const actions = {
  // User Functions
  setUser({ commit }, values) {
    commit("addUserDetail", values);
    UserDetail.setUserID(values._id);
    UserDetail.setUserRole(values.role);
    UserDetail.setUserQuota(values.freeProfileQuota);
    UserDetail.setUserIsDeleted(values.isDeleted);
    UserDetail.setUserName(values.username);
    UserDetail.setUserEmail(values.email);
    UserDetail.setUserFreeQuota(values.freeProfileQuota)
  }
};

const mutations = {
  // User mutations
  addUserDetail: (state, values) => {
    state.role = values.role;
    state.freeProfileQuota = values.freeProfileQuota;
    state.isDeleted = values.isDeleted;
    state._id = values._id;
    state.username = values.username;
    state.email = values.email;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
